export const employeeStatus = [
    {
        id: 1,
        imagepath: 'user/4.jpg',
        title: 'John Deo',
        online: '14+ online',
        position: 'Designer',
        skill: '30%',
        exp: '2 year',
        classname: 'primary'
    },
    {
        id: 2,
        imagepath: 'user/1.jpg',
        title: 'Holio Mako',
        online: '250+ online',
        position: 'Developer',
        skill: '70%',
        exp: '3 year',
        classname: 'secondary'
    },
    {
        id: 3,
        imagepath: 'user/5.jpg',
        title: 'Mohsib lara',
        online: '99+ online',
        position: 'tester',
        skill: '60%',
        exp: '5 month',
        classname: 'primary'
    },
    {
        id: 4,
        imagepath: 'user/6.jpg',
        title: 'Hileri Soli',
        online: '150+ online',
        position: 'Designer',
        skill: '25%',
        exp: '3 month',
        classname: 'secondary'
    },
    {
        id: 5,
        imagepath: 'user/7.jpg',
        title: 'Pusiz bia',
        online: '19+ online',
        position: 'Developer',
        skill: '90%',
        exp: '5 year',
        classname: 'primary'
    }
];

export const cartProducts = [
    {
        id: 1,
        details: 'Simply dummy text of the printing',
        qty: '1',
        status: 'pending',
        statusColor: 'primary',
        price: '6523',
        className: 'pill-badge-secondary'
    },
    {
        id: 2,
        details: 'Long established',
        qty: '5',
        status: 'cancle',
        statusColor: 'secondary',
        price: '6565',
        className: 'pill-badge-success'
    },
    {
        id: 3,
        details: 'sometimes by accident',
        qty: '10',
        status: 'cancle',
        statusColor: 'primary',
        price: '9361',
        className: 'pill-badge-warning'
    },
    {
        id: 4,
        details: 'Classical Latin literature',
        qty: '9',
        status: 'return',
        statusColor: 'primary',
        price: '2658',
        className: 'pill-badge-primary'
    },
    {
        id: 5,
        details: 'keep the site on the Internet',
        qty: '8',
        status: 'pending',
        statusColor: 'primary',
        price: '6328',
        className: 'pill-badge-secondary'
    },
    {
        id: 6,
        details: 'Molestiae consequatur',
        qty: '3',
        status: 'cancle',
        statusColor: 'secondary',
        price: '4852',
        className: 'pill-badge-info'
    },
    {
        id: 7,
        details: 'Pain can procure',
        qty: '8',
        status: 'return',
        statusColor: 'primary',
        price: '3589',
        className: 'pill-badge-primary'
    }
];